import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../Core/hooks';
//import { createProject } from '../Store/Project';
import { ContextMenu } from '../Models/ContextMenu';
import { AddChatChannelContextMenuParams } from '../Models/Requests/AddChatChannelContextMenuParams';
import { AiOutlineClose, AiFillCloseCircle } from "react-icons/ai";
import { getFolder } from '../Store/Folder';
import { BiSearch } from "react-icons/bi";
//import { Member } from '../Models/Requests/Member';
import { getRoadmap } from '../Store/Roadmap';
import { openSocket } from '../Helpers/openSocket';
import { setSocket, getSettings, toggleChatMessages } from '../Store/Settings';
import { getUser } from '../Store/Auth';
import Avatar from '../Components/Avatar';
import { Member } from '../Models/Requests/Member';
import { getChat, setChannels } from '../Store/Chat';
import { Channel } from '../Models/Channel';
import { useIsMobile } from '../Core/hooks';

interface Props {
    params: AddChatChannelContextMenuParams | undefined;    
}

function AddChatChannelContextMenu(props: Props) {

    const dispatch = useAppDispatch();
    const roadmapState = useAppSelector(getRoadmap);
    const settingsState = useAppSelector(getSettings);
    const userState = useAppSelector(getUser);
    const chatState = useAppSelector(getChat);
    const [name, setName] = useState("");
    const [findMember, setFindMember] = useState("");
    const [chatChannelContextMenu, setChatChannelContextMenu] = useState<ContextMenu>();
    const [findMembers, setFindMembers] = useState<Array<Member>>([]);
    const [channelMembers, setChannelMembers] = useState<Array<Member>>([]);
    //const [error, setError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const popupRef = useRef<HTMLDivElement>(null);
    const isMobile = useIsMobile();

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
          if (popupRef.current && popupRef.current === e.target) {
            closeContextMenu(); // Close if clicked outside
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setFindMembers(chatState.findMembers);
    }, [chatState.findMembers]);
    
    useEffect(() => {
        if (props.params) {
            clearState();
            let contextMenu = { _id: "", x: 0, y: 0, width: 0, height: 0 };
            if ((chatChannelContextMenu && chatChannelContextMenu._id !== props.params._id) || !chatChannelContextMenu) {
                let menuWidth = 300;
                let menuXStart = props.params.event.clientX + 15;
                let menuYStart = props.params.event.clientY - 15;
                if (menuXStart > window.outerWidth) {
                    menuXStart = window.outerWidth - 10;
                }
                contextMenu._id = props.params._id;
                contextMenu.x = menuXStart;
                contextMenu.y = menuYStart;
                contextMenu.width = menuWidth;
            }
            setChatChannelContextMenu(contextMenu);
        }
    }, [props.params]);

    const clearState = () => {
        setName("");
        setFindMember("");
        setFindMembers([]);
        setChannelMembers([]);
        setErrorMessage("");
    }

    const showError = (error: string) => {
        //setError(true);
        setErrorMessage(error);
        //setFormSubmitted(false);
        setTimeout(() => setErrorMessage(""), 2000);
    }

    const closeContextMenu = (e?: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        clearState();
        let contextMenu = { _id: "", x: 0, y: 0, width: 0, height: 0 };
        setChatChannelContextMenu(contextMenu);
    }
    
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.currentTarget.value)
    }

    const handleFindMemberChange = (e: React.ChangeEvent<HTMLInputElement>) => {        
        setFindMember(e.currentTarget.value);
        let socket = openSocket(dispatch, settingsState);
        if (socket) {
            //console.log(socket);
            //console.log("Calling getMembers with: " +e.currentTarget.value );
            socket.emit("getMembers", { 
                name: e.currentTarget.value 
            });
        }
    }

    const handleCreateChannel = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (name === "" && props.params?._id === '1') {
            showError("Channel Name is required");
        }

        else if (channelMembers.length === 0) {
            showError("Atleast one member required");
        }

        else {
            let socket = openSocket(dispatch, settingsState);
            if (socket) {
                socket.emit("createChannel", { 
                    name: name,
                    members: channelMembers
                });
                // expand chat on add
                if (props.params?._id !== '1') {
                    dispatch(toggleChatMessages(true));
                }

                closeContextMenu();
            }
        }
    }

    const addMemberToChannel = (e: React.MouseEvent<HTMLDivElement>, member: Member) => {
        e.preventDefault();
        e.stopPropagation();
        let tempMembers = [...channelMembers];
        tempMembers.push(member);
        setChannelMembers(tempMembers);
    }

    const removeChannelMember = (e: React.MouseEvent<HTMLDivElement>, member: Member) => {
        e.preventDefault();
        e.stopPropagation();
        let tempMembers = [...channelMembers];

        let index = channelMembers.findIndex(m => m.email === member.email);
        if (index !== -1) {
            tempMembers.splice(index, 1);
            setChannelMembers(tempMembers);
        }        
    }
    /*
    const sContextMenu: React.CSSProperties = {
        top: (chatChannelContextMenu) ? chatChannelContextMenu.y : 0,
        left: (chatChannelContextMenu) ? chatChannelContextMenu.x : 0,
        width: (chatChannelContextMenu) ? chatChannelContextMenu.width : 300,
        height: "auto",
        paddingBottom: "15px",
    }
    */
    const sContextMenu: React.CSSProperties = {
        top: chatChannelContextMenu && !isMobile ? chatChannelContextMenu.y : 0,
        left: chatChannelContextMenu && !isMobile ? chatChannelContextMenu.x : 0,
        width: isMobile 
            ? "100vw" 
            : chatChannelContextMenu 
                ? chatChannelContextMenu.width 
                : 300,
        height: isMobile ? "100vh" : "auto",
    };

    let formattedMembers = findMembers.map((member, index) => {
        /* don't show possible members if already added as members */
        if (!channelMembers.some(m => m.email === member.email)) {
            return (
                <div style={{ display: "flex", width: "100%", paddingBottom: "10px",
                    justifyContent: "center", alignItems: "center",
                    height: "44px"
                 }}>
                    <div style={{ width: "15%", display: "inline-block", padding: "2px" }}>
                        <Avatar size="small" member={member} />
                    </div>
                    <div style={{ width: "65%", display: "inline-block", textAlign: "left", padding: "2px" }}>
                        {member.firstName} {member.lastName}
                    </div>
                    <div style={{ width: "20%", display: "inline-block", padding: "2px", 
                        fontWeight: "550", cursor: "pointer", fontSize: "10pt" }}
                        onClick={(e) => addMemberToChannel(e, member)}>
                        Add
                    </div>
                    
                </div>
            );
        }
    })

    let formattedChannelMembers = channelMembers.map((member, index) => {
        return (
            <div style={{ display: "flex", width: "100%", paddingBottom: "10px",
                justifyContent: "center", alignItems: "center",
                height: "44px"
            }}>
                <div style={{ width: "15%", display: "inline-block", padding: "2px" }}>
                    <Avatar size="small" member={member} />
                </div>
                <div style={{ width: "65%", display: "inline-block", textAlign: "left", padding: "2px" }}>
                    {member.firstName} {member.lastName}
                </div>
                <div style={{ width: "20%", display: "inline-block", padding: "2px", 
                    fontWeight: "550", cursor: "pointer", fontSize: "10pt" }}
                    onClick={(e) => removeChannelMember(e, member)}>
                    Remove
                </div>
            </div>
        );
    })
//{roadmapState.members.filter(m => m.userId !== userState._id).length > 0 ?
    return (
        <>
        {chatChannelContextMenu && chatChannelContextMenu._id !== "" &&
            <>
            {chatState.allChatMembers.filter(m => m.userId !== userState._id).length > 0 ?
                <div ref={popupRef} className="popupContainer">
                    <div className="contextMenu" style={sContextMenu} onClick={e => { e.preventDefault(); e.stopPropagation()}}>
                        <h1 style={{ marginBottom: "0px" }}>
                            {props.params?._id === '1' ?
                                <>New Channel</>
                            :
                                <>New Chat</>
                            }
                        </h1>
                        <div className="divClose">
                            <Link to="" onClick={(e) => closeContextMenu(e)}>
                                <AiOutlineClose color="#555" size="13" />
                            </Link>
                        </div>
                        {errorMessage !== "" &&
                            <div className="error2" style={{ marginTop: "10px" }}>
                                {errorMessage}
                            </div>
                        }
                        <div style={{ textAlign: "center", paddingTop: "10px" }}>
                            {props.params?._id === '1' &&
                                <div>
                                    <input type="text" 
                                        className="standardInput"
                                        placeholder="Name"
                                        value={name}
                                        onChange={(e) => handleNameChange(e)} 
                                        />
                                </div>
                            }
                            <div className="divFindChatMembers">
                                <div className="divSearchFindChatMembers">
                                    <BiSearch size={20} color="gray" />
                                </div>
                                {findMember.length > 0 &&
                                    <div className="divSearchFindChatMembersClose"
                                        onClick={() => { setFindMember(""); setFindMembers([]); }}>
                                        <AiFillCloseCircle size={20} color="gray" />
                                    </div>
                                } 
                                <div>
                                    <input 
                                        style={{ paddingLeft: "35px" }}
                                        type="text" 
                                        className="standardInput"
                                        placeholder="Find members"
                                        value={findMember}
                                        onChange={(e) => handleFindMemberChange(e)} 
                                        />
                                </div>
                            </div>
                            <div style={{ fontSize: "10pt", fontWeight: "550", padding: "5px" }}>
                                {props.params?._id === '1' ?
                                    <>In this channel</>
                                :
                                    <>In this chat</>
                                }
                            </div>
                            <div style={{ padding: "0px 10px" }}>
                                {formattedChannelMembers.length === 0 ?
                                    <div style={{ textAlign: "center", paddingBottom: "10px", fontStyle: "italic", fontSize: "10pt" }}>
                                        {props.params?._id === '1' ?
                                            <>No members in this channel</>
                                        :
                                            <>No members in this chat</>
                                        }
                                    </div>
                                :
                                    <>{formattedChannelMembers}</>
                                }
                            </div>
                            <div style={{ backgroundColor: "#efefef", fontSize: "10pt", fontWeight: "550", padding: "5px" }}>
                            {props.params?._id === '1' ?
                                <>Not in this channel</>
                            :
                                <>Not in this chat</>
                            }
                            </div>
                            <div style={{ backgroundColor: "#efefef", padding: "0px 10px 10px 10px" }}>
                                {formattedMembers.length === 0 ?
                                    <div style={{ textAlign: "center", fontStyle: "italic", fontSize: "10pt" }}>
                                        use find to locate people to add
                                    </div>
                                :
                                    <>{formattedMembers}</>
                                }
                            </div>
                            <div style={{ marginTop: "13px", textAlign: "left" }}>
                                <Link to="" onClick={(e) => handleCreateChannel(e)} className="btn-orange">
                                    Create
                                </Link> 
                            </div>
                        </div>
                    </div>
                </div>
            :
                <div onClick={e => closeContextMenu(e)} className="popupContainer">
                    <div className="contextMenu" style={sContextMenu} onClick={e => { e.preventDefault(); e.stopPropagation()}}>
                        <h1 style={{ marginBottom: "0px" }}>
                            No Members
                        </h1>
                        <div className="divClose">
                            <Link to="" onClick={(e) => closeContextMenu(e)}>
                                <AiOutlineClose color="#555" size="13" />
                            </Link>
                        </div>
                        <div style={{ textAlign: "left", padding: "10px 20px" }}>
                            You need to create a roadmap and invite others, or be invited by someone else, 
                            before you can create channels or send direct messages.
                        </div>
                    </div>  
                </div>       
            }
            </>
        }
        </>
    );
}

export default AddChatChannelContextMenu;